<template>
  <div class="d-habiente">
    <md-dialog class="md-dialog-newdh" :md-active.sync="showNewDHModal" :md-click-outside-to-close="false">
      <md-dialog-title>Documento de Identificación</md-dialog-title>

      <div class="md-layout-item">
        <md-field>
          <label for="doc">Tipo de Documento</label>
          <md-select v-model="documentType" name="doc" id="doc">
            <md-option value="01">DNI</md-option>
            <md-option value="04">CARNÉ DE EXTRANJERÍA</md-option>
            <md-option value="07">PASAPORTE</md-option>
            <md-option value="23">PTP</md-option>
          </md-select>
        </md-field>
      </div>

      <md-field>
        <label>Número de documento</label>
        <md-input v-model="documentNumber"></md-input>
      </md-field>

      <md-dialog-actions>
        <md-button class="md-accent" @click="showNewDHModal = false">Cancelar</md-button>
        <md-button class="md-primary" @click="setDocument()">Registrar</md-button>
      </md-dialog-actions>
    </md-dialog>

    <div v-if="dh_list.length == 0" class="d-habiente__nodhabiente">
      <div class="d-habiente__nodhabiente-mssg">
        Usted no cuenta con Derechohabientes.
      </div>
      <md-button class="md-raised md-accent" @click="newDH()">Registrar Derechohabiente</md-button>
    </div>

    <div v-else class="d-habiente__wrapper">
      <div class="d-habiente__tabs">
        <div class="d-habiente__tab" :class="{ 'tab-selected': index == nroDH }" v-for="(item, index) in dh_list"
          :key="index" @click="loadDH(index)">
          {{ item.firstName | formatFirstName }}
        </div>

        <div class="d-habiente__add" @click="addDerechoHabiente">+</div>
      </div>
      <div class="d-habiente__body">
        <!-- <div class="d-habiente__first-title">1. Información personal</div> -->

        <md-field>
          <label for="familybond">Vínculo familiar</label>
          <md-select v-model="ldata.familyBond" name="familybond" id="familybond" required>
            <md-option value="02">Cónyuge</md-option>
            <md-option value="03">Concubina(o)</md-option>
            <md-option value="04">Gestante</md-option>
            <md-option value="05">Hijo menor de edad</md-option>
            <md-option value="06">Hijo mayor Incap. Perm.</md-option>
            <md-option value="00">Deshabilitar Derecho Habiente</md-option>
          </md-select>
        </md-field>

        <md-field>
          <label for="typedoc">Tipo de documento</label>
          <md-select v-model="ldata.documentType" name="typedoc" id="typedoc" required>
            <md-option value="01">DNI</md-option>
            <md-option value="23">Carné PTP</md-option>
          </md-select>
        </md-field>

        <!-- numero de documento -->
        <md-field :class="getValidationClass($v.ldata.documentNumber)">
          <label>Número Documento</label>
          <md-input name="nroDocumento" id="nroDocumento" v-model="ldata.documentNumber" required></md-input>
          <span class="md-error" v-if="!$v.ldata.documentNumber.required">Número de documento es requerido</span>
          <span class="md-error" v-if="!$v.ldata.documentNumber.numeric">Documento no válido</span>
        </md-field>

        <!-- fecha de nacimiento -->
        <md-field>
          <label>Fecha de Nacimiento</label>
          <v-date-picker v-model="dateBorn" class="datepick" popover-visibility="focus" :max-date="new Date()">
            <md-input slot-scope="{ inputValue }" style="text-align: left !important" :value="inputValue" readonly
              required></md-input>
          </v-date-picker>
        </md-field>

        <!-- nombres -->
        <md-field :class="getValidationClass($v.ldata.firstName)">
          <label>Nombres</label>
          <md-input name="nombre" id="nombre" v-model="ldata.firstName" style="color: red !important" required></md-input>
          <span class="md-error" v-if="!$v.ldata.firstName.required">Nombres son requeridos</span>
          <span class="md-error" v-if="!$v.ldata.firstName.isAlpha">Nombre no válido</span>
        </md-field>

        <!-- apellido paterno -->
        <md-field :class="getValidationClass($v.ldata.firstSurname)">
          <label>Apellido Paterno</label>
          <md-input name="apPaterno" id="apPaterno" v-model="ldata.firstSurname" required></md-input>
          <span class="md-error" v-if="!$v.ldata.firstSurname.required">Apellido paterno es requerido</span>
          <span class="md-error" v-if="!$v.ldata.firstSurname.isAlpha">Campo requiere solo letras</span>
        </md-field>

        <!-- apellido materno -->
        <md-field :class="getValidationClass($v.ldata.secondSurname)">
          <label>Apellido Materno</label>
          <md-input name="apMaterno" id="apMaterno" v-model="ldata.secondSurname" required></md-input>
          <span class="md-error" v-if="!$v.ldata.secondSurname.required">Apellido materno es requerido</span>
          <span class="md-error" v-if="!$v.ldata.secondSurname.isAlpha">Campo requiere solo letras</span>
        </md-field>

        <!-- correo electronico -->
        <md-field :class="getValidationClass($v.ldata.email)">
          <label>Correo Electrónico</label>
          <md-input name="correoE" id="correoE" v-model="ldata.email"></md-input>
          <span class="md-error" v-if="!$v.ldata.email.email">Correo electrónico no válido</span>
        </md-field>

        <!-- género -->
        <div class="field-radio">
          <div class="field-radio__label">Sexo</div>
          <md-radio v-model="ldata.gender" value="male">Masculino</md-radio>
          <md-radio v-model="ldata.gender" value="female">Femenino</md-radio>
        </div>

        <!-- <div class="d-habiente__second-title">2. Dirección</div> -->

        <!-- pais -->
        <!-- <md-field>
      <label for="pais">País</label>
      <md-select v-model="ldata.country" name="pais" id="pais" placeholder="País" required>
        <md-option value="peru">Perú</md-option>
        <md-option value="brasil">Brasil</md-option>
      </md-select>
        </md-field>-->

        <!-- departamento -->
        <!-- <md-field>
      <label for="departamento">Departamento</label>
      <md-select
        v-model="ldata.department"
        name="departamento"
        id="departamento"
        placeholder="Departamento"
        required>
        <md-option value="lima">Lima</md-option>
        <md-option value="Arequipa">Arequipa</md-option>
      </md-select>
        </md-field>-->

        <!-- provincia -->
        <!-- <md-field>
      <label for="provincia">Provincia</label>
      <md-select
        v-model="ldata.province"
        name="provincia"
        id="provincia"
        placeholder="Provincia"
        required>
        <md-option value="lima">Lima</md-option>
        <md-option value="huaral">Huaral</md-option>
      </md-select>
        </md-field>-->

        <!-- distrito -->
        <!-- <md-field>
      <label for="distrito">Distrito</label>
      <md-select
        v-model="ldata.district"
        name="distrito"
        id="distrito"
        placeholder="Distrito"
        required>
        <md-option value="cercado">Cercado de Lima</md-option>
        <md-option value="bellavista">Bellavista</md-option>
        <md-option value="carabayllo">Carabayllo</md-option>
      </md-select>
        </md-field>-->

        <!-- zona domicilio -->
        <md-field class="direccion">
          <label>Dirección Domicilio</label>
          <md-input name="zonaDomicilio" id="zonaDomicilio" v-model="direccion" required
            style="text-transform: capitalize" @click="showDirectionModal = true"></md-input>
        </md-field>

        <!-- modal -->
        <md-dialog :md-active.sync="showDirectionModal" :md-click-outside-to-close="false">
          <md-dialog-title>Dirección</md-dialog-title>
          <div class="container-md">
            <md-autocomplete v-model="roadType" :md-options="roadTypes" md-input-id="roadtype" md-dense
              @md-selected="selectVia" required class="buscador">
              <label>Tipo de Vía</label>
              <template slot="md-autocomplete-item" slot-scope="{ item }">{{
                item.name
              }}</template>
            </md-autocomplete>

            <md-field>
              <label>Nombre de vía</label>
              <md-input v-model="ldata.address.roadName"></md-input>
            </md-field>

            <md-autocomplete v-model="zoneType" :md-options="zoneTypes" md-input-id="zonetype" md-dense
              @md-selected="selectZone" required class="buscador">
              <label>Tipo de Zona</label>
              <template slot="md-autocomplete-item" slot-scope="{ item }">{{
                item.name
              }}</template>
            </md-autocomplete>

            <md-field>
              <label>Nombre de Zona</label>
              <md-input v-model="ldata.address.zoneName"></md-input>
            </md-field>

            <div class="container-md__group">
              <md-field>
                <label>Nro vía</label>
                <md-input v-model="ldata.address.roadNumber"></md-input>
              </md-field>
              <md-field>
                <label>Bloque</label>
                <md-input v-model="ldata.address.block"></md-input>
              </md-field>
              <md-field>
                <label>Dpto</label>
                <md-input v-model="ldata.address.flat"></md-input>
              </md-field>
              <md-field>
                <label>Interior</label>
                <md-input v-model="ldata.address.interior"></md-input>
              </md-field>
              <md-field>
                <label>Manzana</label>
                <md-input v-model="ldata.address.square"></md-input>
              </md-field>
              <md-field>
                <label>Lote</label>
                <md-input v-model="ldata.address.lot"></md-input>
              </md-field>
              <md-field>
                <label>Kilómetro</label>
                <md-input v-model="ldata.address.km"></md-input>
              </md-field>
              <md-field>
                <label>Etapa</label>
                <md-input v-model="ldata.address.stage"></md-input>
              </md-field>
              <md-field>
                <label>Ubigeo</label>
                <md-input v-model="ldata.address.ubigeo"></md-input>
              </md-field>
            </div>
          </div>
          <md-dialog-actions v-if="show">
            <md-button class="md-accent" @click="showDirectionModal = false">Cerrar</md-button>
            <md-button class="md-primary" @click="loadDirection()">Guardar</md-button>
          </md-dialog-actions>
        </md-dialog>
        <!-- <md-field> -->
        <md-button class="md-raised md-accent d-habiente__save" @click="saveDH()">Guardar</md-button>

        <!-- </md-field> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { required, email, numeric, helpers } from "vuelidate/lib/validators";

const isAlpha = helpers.regex("alpha", /^[a-zA-ZÀ-ÿñÑ ]*$/);

export default {
  props: {
    value: Object,
    isHistoric: Boolean,
    historicId: String,
  },
  created() {
    console.log("created, isHistoric: ", this.isHistoric);
    if (this.value.rightholders.length > 0) {
      this.dh_list = this.value.rightholders;
      this.nroDH = 0;
      this.ldata = this.dh_list[0];

      if (this.ldata.address.roadType)
        this.roadType = this.roadTypes.filter(
          (item) => item.code == this.ldata.address.roadType
        )[0].name;

      if (this.ldata.address.zoneType)
        this.zoneType = this.zoneTypes.filter(
          (item) => item.code == this.ldata.address.zoneType
        )[0].name;

      if (this.ldata.address.roadType && this.ldata.address.zoneType) {
        console.log("hola amiito");
        this.loadDirection();
      }
    }
  },
  activated() {
    console.log("activated, isHistoric: ", this.isHistoric);
    if (this.value.rightholders.length > 0) {
      this.dh_list = this.value.rightholders;
      this.nroDH = 0;
      this.ldata = this.dh_list[0];

      if (this.ldata.address.roadType)
        this.roadType = this.roadTypes.filter(
          (item) => item.code == this.ldata.address.roadType
        )[0].name;

      if (this.ldata.address.zoneType)
        this.zoneType = this.zoneTypes.filter(
          (item) => item.code == this.ldata.address.zoneType
        )[0].name;

      if (this.ldata.address.roadType && this.ldata.address.zoneType) {
        console.log("hola amiito");
        this.loadDirection();
      }
    }
  },
  deactivated() {
    console.log("deactivated");
    this.dh_list = [];
    this.nroDH = null;
    this.ldata = {
      address: {
        roadType: "",
        roadName: "",
        roadNumber: "",
        flat: "",
        interior: "",
        square: "",
        lot: "",
        km: "",
        block: "",
        stage: "",
        zoneType: "",
        zoneName: "",
        reference: "",
        ubigeo: "",
      },
    };
  },
  data() {
    return {
      //new DH Modal
      showNewDHModal: false,
      documentType: null,
      documentNumber: null,

      dh_list: [],
      nroDH: null,
      address: null,
      roadType: null,
      roadTypes: [
        { code: "01", label: "Av", name: "Avenida" },
        { code: "02", label: "Jr", name: "Jirón" },
        { code: "03", label: "Ca", name: "Calle" },
        { code: "04", label: "Pje", name: "Pasaje" },
        { code: "05", label: "Al", name: "Alameda" },
        { code: "06", label: "Ml", name: "Malecón" },
        { code: "07", label: "Ov", name: "Óvalo" },
        { code: "08", label: "Pq", name: "Parque" },
        { code: "09", label: "Pl", name: "Plaza" },
        { code: "10", label: "Cr", name: "Carretera" },
        { code: "14", label: "Cm", name: "Camino Rural" },
        { code: "15", label: "Ba", name: "Bajada" },
        { code: "16", label: "Ga", name: "Galería" },
        { code: "17", label: "Pr", name: "Prolongación" },
        { code: "18", label: "Pas", name: "Paseo" },
        { code: "19", label: "Pz", name: "Plazuela" },
        { code: "99", label: "Vía", name: "Otro" },
      ],
      zoneType: null,
      zoneTypes: [
        { code: "01", label: "URB.", name: "Urbanización" },
        { code: "02", label: "P.J.", name: "Pueblo Joven" },
        { code: "03", label: "U.V.", name: "Unidad Vecinal" },
        { code: "04", label: "C.H.", name: "Conjunto Habitacional" },
        { code: "05", label: "A.H.", name: "Asentamiento Humano" },
        { code: "06", label: "COO.", name: "Cooperativa" },
        { code: "07", label: "RES.", name: "Residencial" },
        { code: "08", label: "Z.I.", name: "Zona Industrial" },
        { code: "09", label: "GRU.", name: "Grupo" },
        { code: "10", label: "CAS.", name: "Caserío" },
        { code: "11", label: "FND.", name: "Fundo" },
        { code: "99", label: "Zona", name: "Otros" },
      ],
      direccion: null,

      ldata: {
        address: {
          roadType: "",
          roadName: "",
          roadNumber: "",
          flat: "",
          interior: "",
          square: "",
          lot: "",
          km: "",
          block: "",
          stage: "",
          zoneType: "",
          zoneName: "",
          reference: "",
          ubigeo: "",
        },
      },
      showDirectionModal: false,
    };
  },

  validations: {
    ldata: {
      documentNumber: { numeric, required },
      firstName: { isAlpha, required },
      firstSurname: { isAlpha, required },
      secondSurname: { isAlpha, required },
      email: { email },
    },
    address: { required },
  },

  computed: {
    ...mapState({
      idCurrentTR: (state) => state.business.currentTRegister,
    }),

    dateBorn: {
      get() {
        // if(!this.ldata.bornDate)
        //   return new Date()
        return new Date(this.ldata.bornDate);
      },
      set(value) {
        this.ldata.bornDate = value.toISOString();
      },
    },
    show() {
      return ["owner", "master", "manager"].includes(this.$store.getters.roleIn);
    },
  },

  filters: {
    formatFirstName(name) {
      return String(name).split(" ")[0];
    },
  },

  methods: {
    ...mapActions({
      getTRegister: "getTRegister",
      createRightholder: "createRightholder",
      updateRightholder: "updateRightholder",
    }),

    getValidationClass(validation) {
      if (validation.$model === null) {
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      } else {
        validation.$touch();
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      }
    },

    saveDirection() {
      this.address = [
        this.ldata.address.roadType,
        "Km " + this.ldata.address.km,
        this.ldata.address.roadName,
        "Nro " + this.ldata.address.roadNumber,
        "Dpto " + this.ldata.address.flat,
        "Int " + this.ldata.address.interior,
        "Bloque " + this.ldata.address.block,
        "Mza " + this.ldata.address.square,
        "Lote " + this.ldata.address.lot,
        this.ldata.address.zoneType.toUpperCase() + " " + this.ldata.address.zoneName,
      ]
        .filter((r) => !r.includes("null") && r[r.length - 1] != " ")
        .join(" ");

      // this.ldata.address = [this.ldata.typeVia,this.ldata.viaName,'Nro '+this.ldata.nVia,'Bloque '+this.ldata.block,'Dpto '+this.ldata.dpto,'Int '+this.ldata.int,'Mza '+this.ldata.mza,'Lote '+this.ldata.lote,'Km '+this.ldata.km].filter(r => !r.includes('null')).join(' ') + ' ' + this.ldata.department + ' - ' + this.ldata.province + ' - ' + this.ldata.district

      this.showDirectionModal = false;
    },

    loadDirection() {
      this.direccion = [
        this.roadTypes.filter(
          (item) => item.name == this.roadType || item.code == this.ldata.address.roadType
        )[0].label,
        this.ldata.address.roadName,
        "Nro " + this.ldata.address.roadNumber,
        "Bloque " + this.ldata.address.block,
        "Dpto " + this.ldata.address.flat,
        "Int " + this.ldata.address.interior,
        "Mza " + this.ldata.address.square,
        "Lote " + this.ldata.address.lot,
        "Km " + this.ldata.address.km,
        this.zoneTypes.filter(
          (item) => item.name == this.zoneType || item.code == this.ldata.address.zoneType
        )[0].label,
        this.ldata.address.zoneName,
        "Etapa " + this.ldata.address.stage,
      ]
        .filter((r) => r[r.length - 1] != " ")
        .join(" ");

      this.showDirectionModal = false;
    },

    selectVia(value) {
      (this.roadType = value.name), (this.ldata.address.roadType = value.code);
    },

    selectZone(value) {
      (this.zoneType = value.name), (this.ldata.address.zoneType = value.code);
    },

    setDocument() {
      this.createRightholder({
        id: this.value.id,
        data: {
          documentNumber: this.documentNumber,
          documentType: this.documentType,
          bornDate: new Date().toISOString(),
        },
      }).then((r) => {
        if (r.status == 200) {
          console.log("nuevo DH creado");
          this.getTRegister().then((r) => {
            if (r.status == 200) {
              console.log("actualizando dhbs");
              this.dh_list = r.data.rightholders;
              if (this.dh_list.length > 1) {
                this.nroDH = this.dh_list.length - 1;
                this.ldata = this.dh_list[this.nroDH];
              } else {
                this.nroDH = 0;
                this.ldata = this.dh_list[0];
                console.log(this.ldata);
                this.$set(
                  this.ldata,
                  "address",
                  JSON.parse(JSON.stringify(this.value.address))
                );
                // this.zoneType = this.zoneTypes.filter(item => item.code == this.ldata.address.zoneType)[0]
                // this.roadType = this.roadTypes.filter(item => item.code == this.ldata.address.roadType)[0]
              }
              // this.ldata.bornDate = this.dateBorn.toISOString()
              this.showNewDHModal = false;
            }
          });
        }
      });
    },

    newDH() {
      console.log(this.value);

      this.showNewDHModal = true;

      // this.ldata.address = JSON.parse(JSON.stringify(this.value.address))
    },

    loadDH(index) {
      this.nroDH = index;
      this.ldata = this.dh_list[index];

      this.direccion = null;
      this.roadType = null;
      this.zoneType = null;

      if (this.ldata.address.roadType)
        this.roadType = this.roadTypes.filter(
          (item) => item.code == this.ldata.address.roadType
        )[0].name;

      if (this.ldata.address.zoneType)
        this.zoneType = this.zoneTypes.filter(
          (item) => item.code == this.ldata.address.zoneType
        )[0].name;

      if (this.ldata.address.roadType && this.ldata.address.zoneType) {
        console.log("hola amiito");
        this.loadDirection();
      }
    },

    addDerechoHabiente() {
      this.showNewDHModal = true;
      this.direccion = null;
      this.roadType = null;
      this.zoneType = null;
      this.documentNumber = null;
      this.documentType = null;
    },

    async saveDH() {
      let res, message;
      if (this.isHistoric) {
        console.log("derecho habiente historico actualizar t-registro historico");
        console.log(this.value, this.ldata);
        this.value.rightholders = this.dh_list;
        res = await this.$store.dispatch("updateTregistersHistoric", {
          id: this.$store.state.business.currentTRegister,
          fk: this.historicId,
          body: this.value,
        });
        message = "T-registro Historico actualizado";
        if (res.status === 200) {
          this.$toasted.success(message, {
            theme: "bubble",
            position: "top-right",
            duration: 1000,
            className: "short-message",
          });
        }
      } else {
        this.updateRightholder(this.ldata).then((r) => {
          if (r.status == 200) {
            console.log("Derechohabiente actualizado");
            this.getTRegister(this.idCurrentTR).then((r) => {
              if (r.status == 200) {
                console.log("nueva lista de dhbs ...");
                this.dh_list = r.data.rightholders;
              }
            });
          }
        });
      }
    },
  },
  watch: {
    value: {
      handler: function (n, o) {
        console.log(n.rightholders, o.rightholders);
        if (n) {
          if (n.rightholders.length > 0) {
            this.dh_list = n.rightholders;
            this.nroDH = 0;
            this.ldata = this.dh_list[0];

            if (this.ldata.address.roadType)
              this.roadType = this.roadTypes.filter(
                (item) => item.code == this.ldata.address.roadType
              )[0].name;

            if (this.ldata.address.zoneType)
              this.zoneType = this.zoneTypes.filter(
                (item) => item.code == this.ldata.address.zoneType
              )[0].name;

            if (this.ldata.address.roadType && this.ldata.address.zoneType) {
              console.log("hola amiito");
              this.loadDirection();
            }
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}

//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//8-TRUMPS
//vue-material
.md-field {
  width: 18rem;
  // margin: 0 2rem 2rem 24px;

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);

      &::after {
        color: $b-orange;
      }
    }

    &::after {
      background-color: #d7dae2;
    }

    &::before {
      background-color: $b-blue;
    }

    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }

      &::after {
        background-color: $b-orange;
      }

      .md-error {
        color: $b-orange;
      }
    }
  }
}

//modal dialog
.md-dialog {
  z-index: 900;
  padding: 1rem 3rem;
  max-width: 30rem;
  overflow: hidden auto;
  max-height: none;

  @include mq($sm) {
    height: 45rem;
    max-height: 46rem;
  }
}

.md-dialog-newdh {
  @include mq($sm) {
    height: auto;
  }

  @include mq($md) {
    height: auto;
  }
}

.container-md {
  display: flex;
  flex-wrap: wrap;

  @include mq($md) {}

  &__group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @include mq($md) {
      // width: 100%;
    }

    .md-field {
      width: 6rem;
      margin-right: 1rem;

      @include mq($md) {
        width: 6rem;
      }
    }
  }
}

.direccion {
  @include mq($md) {
    width: 30rem;
  }
}

.field-radio {
  // margin: 0 2rem 1rem 24px;
  width: 18rem;
  padding-top: 16px;
  position: relative;

  &__label {
    position: absolute;
    top: 0;
    font-size: 12px;
    color: rgba($b-blue, 0.6);
  }
}

.tab-selected {
  background-color: #fff !important;
  font-weight: 700 !important;
  border: 1px solid rgba($b-orange, 0.75) !important;
  border-bottom: 1px solid white !important;
}

.d-habiente {
  &__nodhabiente {
    width: 21rem;
    margin: 9rem auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-mssg {
      text-align: center;
      margin-bottom: 2rem;
      font-size: 2rem;
      line-height: 2rem;
      font-weight: 500;
    }
  }

  &__tabs {
    display: flex;
    padding-left: 1rem;

    @include mq($sm) {
      padding-left: 3rem;
    }
  }

  &__tab {
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    background-color: #e6e6e6;
    color: $b-blue-dark;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    transition: background-color 0.3s ease-in-out;

    @include mq($md) {
      cursor: pointer;
    }
  }

  &__add {
    padding: 0.5rem 0;
    background-color: $b-orange;
    color: white;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    width: 2.5rem;
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;

    @include mq($md) {
      cursor: pointer;
    }
  }

  &__first-title,
  &__second-title {
    width: 100%;
    font-weight: 500;
    color: $b-orange;
    text-transform: uppercase;
  }

  &__second-title {
    margin: 2rem 0;
  }

  &__body {
    padding: 1rem 1rem 3rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    @include mq($sm) {
      padding: 1rem 3rem 3rem 3rem;
      width: 90%;
      max-width: 51rem;
    }

    @include mq($md) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  &__save {
    color: #fff !important;
    width: 15rem;

    @include mq($md) {
      width: 16rem;
      margin: 1rem auto 0 auto;
    }
  }
}
</style>
